import { defineComponent as _defineComponent } from 'vue'
import { CoverageState } from '@/enum/CoverageState';
import { CoverageStep } from '@/enum/CoverageStep';
import { AloMission } from  '@/models/alo/AloMission'     
  import { AloDbCoverageIteration } from '@/models/alodb/AloDbCoverageIteration'
  import apiHelpers from '@/utils/api'
import { computed } from 'vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CoverageDetailFileTransfertGlider',
  props: {
    coverageIteration: null,
    mission: null,
    glider: null,
    uiid: null
  },
  setup(__props: any) {

const props = __props as {coverageIteration:AloDbCoverageIteration,mission:AloMission,glider:string,uiid:string};
    
  
  function downloadFile(url:string){
      apiHelpers.downloadFile(url,'.csv')
  }

  const finishedSimulation = computed( () => {
    return (props.coverageIteration.COV_PROCESSING_STATE == CoverageState.finished || props.coverageIteration.COV_PROCESSING_STATE == CoverageState.aborted) && props.coverageIteration.COV_PROCESSING_STEP == CoverageStep.FinalSimulation
  })
  

return { __sfc: true,props, downloadFile, finishedSimulation }
}

})